<template>
  <div class="creditCardLogo__container">
    <a
      @click.prevent="onClick"
      :href="link"
      :title="title"
      class="creditCardLogo__link"
    >
      <img
        :src="src || defaultSrc"
        :title="title"
        :alt="alt || title"
        class="creditCardLogo__img"
        loading="lazy"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'CreditCardLogo',
  props: {
    src: {
      required: true
    },
    title: {
      default: 'Hubbell'
    },
    alt: {
      default: 'Hubbell'
    },
    link: {
      type: String,
      default: '/'
    }
  },
  methods: {
    onClick () {
      this.$emit('clicked')
      this.$router.push(this.link)
    }
  }
}
</script>
